import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { PerformanceService } from '../../service/performance.service';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.less'
})
export class CookieBannerComponent implements OnInit {
  performanceService = inject(PerformanceService);
  isVisible = false;

  ngOnInit() {
    this.isVisible = this.performanceService.getTelemetryStatus() === null;
  }

  accept() {
    this.performanceService.acceptTelemetry();
    this.isVisible = false;
  }

  decline() {
    this.performanceService.declineTelemetry();
    this.isVisible = false;
  }
}
